export default function (fn: Function) {
  let done = false;
  return function (...args: any[]) {
    if (done) return;
    done = true;
    fn(...args);
  };
}
